import { render, staticRenderFns } from "./InboundManagement.vue?vue&type=template&id=5f59ab4e&scoped=true"
import script from "./InboundManagement.vue?vue&type=script&lang=js"
export * from "./InboundManagement.vue?vue&type=script&lang=js"
import style0 from "./InboundManagement.vue?vue&type=style&index=0&id=5f59ab4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f59ab4e",
  null
  
)

export default component.exports